// extracted by mini-css-extract-plugin
export var formButtonsContainer = "styles-module__formButtonsContainer___AoYDN";